// extracted by mini-css-extract-plugin
export default {"CardGrid":"CardGrid_CardGrid__IdSXD","CardGrid__card":"CardGrid_CardGrid__card__m9u8S"};